<template>
  <a-locale-provider :locale="locale">
    <div id="app-root">
      <a-layout class="layout" :class="{ 'watch-mode': isWatch, 'login-mode': isLogin }">
        <a-layout-header v-if="showHeader" class="header">
          <div class="brand" @click="$router.push('/')">南京捷奥</div>
          <a-menu
            v-if="!isLogin"
            theme="dark"
            mode="horizontal"
            :selected-keys="[selectedKey]"
            :style="{ lineHeight: '64px', flex: 1 }"
          >
            <a-menu-item key="home" @click="$router.push('/')">上传与查找</a-menu-item>
          </a-menu>
          <div v-if="loggedIn" class="user-area">
            <span class="username">{{ username }}</span>
            <a-button type="link" style="color: #fff" @click="handleLogout">退出</a-button>
          </div>
        </a-layout-header>
        <a-layout-content
          class="content"
          :class="{ 'content-watch': isWatch, 'content-login': isLogin }"
        >
          <router-view />
        </a-layout-content>
      </a-layout>
    </div>
  </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { clearAuth, getUsername, isLoggedIn } from './utils/auth'
import { logout } from './api/auth'

export default {
  name: 'App',
  data() {
    return {
      locale: zhCN
    }
  },
  computed: {
    isWatch() {
      return this.$route.name === 'Watch'
    },
    isLogin() {
      return this.$route.name === 'Login'
    },
    showHeader() {
      return !this.isWatch
    },
    selectedKey() {
      return this.$route.name === 'Home' ? 'home' : ''
    },
    loggedIn() {
      return isLoggedIn()
    },
    username() {
      return getUsername() || '管理员'
    }
  },
  methods: {
    async handleLogout() {
      try {
        await logout()
      } catch (e) {
        // ignore
      }
      clearAuth()
      this.$message.success('已退出')
      this.$router.replace({ name: 'Login' })
    }
  }
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}
.layout {
  min-height: 100vh;
}
.layout.watch-mode {
  background: #000;
}
.header {
  display: flex;
  align-items: center;
}
.brand {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-right: 24px;
  cursor: pointer;
  white-space: nowrap;
}
.user-area {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.username {
  color: rgba(255, 255, 255, 0.85);
  margin-right: 4px;
}
.content {
  padding: 24px;
  background: #f0f2f5;
  min-height: calc(100vh - 64px);
}
.content-watch {
  padding: 0;
  background: #000;
  min-height: 100vh;
}
.content-login {
  background: linear-gradient(160deg, #f5f7fa 0%, #e8eef5 100%);
}
</style>
